module.exports = __webpack_public_path__ + "static/img/footer.cdd2bc83.jpg";